export enum CurriculumItemResourceType {
    Video = 1,
    Audio = 2,
    Word = 3,
    Excel = 4,
    Presentation = 5,
    PDF = 6,
    File = 7,
    Text = 8,
    Scorm = 9,
    LTI = 10,
}
